import { useEdges } from '../useEdges';

import { createSelectedHook } from '~/core/utils';
import { useDrawingShapeContext } from '~/legacy/easy-estimator-page/context';
import { selectUserSelectedEdge } from '~/redux/slices/edge';

export const _useSelectedEdge = createSelectedHook({
  selector: selectUserSelectedEdge,
  apiQueryHook: useEdges,
  shouldReturnDefault: ({ selectedValue, apiHookResponse }) =>
    !selectedValue ||
    !apiHookResponse.sortedEdges.some(
      (edge) => edge.productId === selectedValue?.productId
    ),
  selectDefaultValue: ({ apiHookResponse }) => apiHookResponse.sortedEdges[0],
});

export const useSelectedEdge = () => {
  const { selectedValue, ...rest } = _useSelectedEdge();
  const { sortedEdges: edges } = useEdges();
  const {
    getters: { activeDrawingShape },
  } = useDrawingShapeContext();

  const activeDrawingEdge = edges.find(
    (dShape) => dShape.productId === activeDrawingShape?.edge?.productId
  );

  return { ...rest, selectedValue: activeDrawingEdge ?? selectedValue };
};
